export enum UserStatus {
	INACTIVE = 'Inactive',
	ACTIVE = 'Active',
	NOT_VALIDATED = 'NotValidated',
	DELETED = 'Deleted',
}
